export default __webpack_public_path__ + "static/media/Aut21.191e8f32.JPG";